import React from "react";
import { Box } from "@UI/Components/Box/Box";
import { VStack } from "@UI/Components/Stack/Stack";
import { Image } from "@UI/Components/Image/Image";
import { Text } from "@UI/Components/Text/Text";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";

// not sure what the heck is going on with the assets inside images/cat/svg
// anyways this it trying to map images/cat/svg to correct p_category id.
// the asset inside images/cat/svg/s_cat file name is correctly name as the p_cat but it's called s_cat
const get_pCategoriesId = new Map([
  [1, 4],
  [2, 5],
  [3, 10],
  [4, 8],
  [5, 6],
  [6, 2],
  [7, 9],
  [8, 7],
  [9, 3],
  [10, 11],
]);

export const CategoryCard = ({
  itemNumber,
  onClick,
}: {
  itemNumber: number;
  onClick: (queryParams: { categoryId: number; step: string }) => void;
}) => {
  const title = (
    <FormattedMessage {...messages[`category.title.${itemNumber}`]} />
  );
  const description = (
    <FormattedMessage {...messages[`category.body.${itemNumber}`]} />
  );

  return (
    <VStack
      minW={{ base: "152px", lg: "166px" }}
      bg="white"
      borderWidth="1px"
      borderRadius="10px"
      overflow="hidden"
      p="12px"
      spacing="8px"
      as="button"
      onClick={() =>
        onClick({
          categoryId: get_pCategoriesId.get(itemNumber),
          step: "2",
        })
      }
    >
      <Image
        src={require(`assets/images/cat/svg/${itemNumber}.svg`)}
        w="28px"
        h="28px"
        alt={"Cat"}
        sx={{ "user-drag": "none" }}
      />

      <Box textAlign="center">
        <Text fontSize="md" fontWeight="bold" color="gray.800" m="0">
          {title}
        </Text>

        <Text fontSize="xs" m="0">
          {description}
        </Text>
      </Box>
    </VStack>
  );
};
